import * as React from "react";
import { asThemeConsumer } from "../../../../theme/Theme";
import { joinClasses } from "../../../../utils/Filters";
/**
 *
 * @param props
 */
var FlexRowComp = function (props) {
    var appRowClassName = props.isCollapsed ? "scl-b-app__row-collapsed" : "scl-b-app__row";
    var scrollableClassName = !!props.isScrollable
        ? "scl-b-app__row--scrollable"
        : undefined;
    var isFixedClassName = !!props.isFixed
        ? "scl-b-app__row--fixed"
        : undefined;
    var verticalAlignContentClassName = !!props.verticalAlignContent
        ? "scl-b-app__row--v-center"
        : undefined;
    var className = joinClasses(props.className, "scl-h-background", appRowClassName, scrollableClassName, isFixedClassName, verticalAlignContentClassName);
    return (React.createElement("div", { className: className, ref: props.scrollRef, style: props.style }, props.children));
};
/**
 *
 */
export var FlexRow = asThemeConsumer(FlexRowComp);
